
import { cn } from '@/lib/utils';

interface SectionIndicatorProps {
  mbtiPhase: 'EI' | 'SN' | 'TF' | 'JP' | 'career';
}

const SectionIndicator = ({ mbtiPhase }: SectionIndicatorProps) => {
  const getMbtiPhaseDescription = (phase: 'EI' | 'SN' | 'TF' | 'JP' | 'career') => {
    switch (phase) {
      case 'EI':
        return "Extraversion vs. Introversion - How you interact with the world and where you get your energy";
      case 'SN':
        return "Sensing vs. Intuition - How you take in information and what you pay attention to";
      case 'TF':
        return "Thinking vs. Feeling - How you make decisions and what you value";
      case 'JP':
        return "Judging vs. Perceiving - How you organize your life and approach structure";
      case 'career':
        return "Career Preferences - Your approach to work and professional development";
      default:
        return "";
    }
  };

  return (
    <div className="mb-6 text-center">
      <span className={cn(
        "section-tag",
        mbtiPhase === 'career' 
          ? "bg-secondary/10 text-secondary" 
          : "bg-primary/10 text-primary"
      )}>
        {mbtiPhase === 'career' ? 'Career Preferences' : 'MBTI Assessment - ' + mbtiPhase}
      </span>
      
      <p className="text-sm text-muted-foreground">
        {getMbtiPhaseDescription(mbtiPhase)}
      </p>
    </div>
  );
};

export default SectionIndicator;
